import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from "react-router-dom";
import queryString from 'utils/queryString';
import { getGhollakProfitCalculations } from "services/ghollak.routes";
import { toast } from "react-toastify";
import InvestorTable from "layouts/investor/InvestorTable";
import InfiniteScroll from "react-infinite-scroll-component";
import ProfitCalculationTable from "./ProfitCalculationTable";

export default function ProfitCalculation() {
    const [searchParams] = useSearchParams()
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [ghollakMinBalance, setGhollakMinBalance] = useState([]);
    const [trigger, setTrigger] = useState(null);
    const [searchInfo, setSearchInfo] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSearchInfo({ ...searchInfo, [name]: value });
    };

    const firstRender = useRef(true);

    useEffect(() => {
        if (
            firstRender.current &&
            searchParams.get("investmentOpportunityId")
        ) {
            firstRender.current = false;
            return;
        }
        firstRender.current = false;

        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            per_page: 30,
            ghollak_id: searchInfo.ghollak_id || null,
            investment_opportunity_id: searchInfo.investment_opportunity_id || null,
        };
        getGhollakProfitCalculations(queryString(query), trigger !== null, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            }
            if (page !== 0) {
                setGhollakMinBalance((prev) => [...prev, ...data.data]);
            } else {
                setGhollakMinBalance(data.data);
            }

            setLoading(false);
            setCursor(data?.meta?.next_cursor === null ? "" : data?.meta?.next_cursor);
            setHasMore(data?.meta?.next_cursor !== null);
        });
    }, [page, trigger]);

    const onFilterClick = () => {
        setPage(0);
        setCursor('');
        setTrigger(Math.random());
    }
    const onClearFilterClick = () => {
        setSearchInfo({})
        onFilterClick()
    }
    useEffect(() => {
        if (searchParams.get("investmentOpportunityId")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setSearchInfo({ investment_opportunity_id: searchParams.get("investmentOpportunityId") })
            setCursor(null);
        }
    }, [searchParams.get("investmentOpportunityId")]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={ghollakMinBalance.length} next={fetchMoreData} hasMore={hasMore}>
                <ProfitCalculationTable data={ghollakMinBalance} filterInfo={searchInfo} handleFilterChange={handleChange} onClearFilterClick={onClearFilterClick} onFilterClick={onFilterClick} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
